/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IHouseOfferHistoryRequestV5 {
  /** Идентификатор дома realty **/
  houseId: number;
  /** Площадь объекта **/
  totalArea: number;
  /** Номер страницы результатов **/
  page?: number;
  /** Кол-во результатов в ответе **/
  resultsOnPage?: number;
  /** Отдать объявления в соседних домах **/
  isNearby?: THouseOfferHistoryRequestV5_IsNearby;
  /** Тип сделки **/
  dealType?: EDealType;
  /** Количество комнат **/
  roomsCount?: THouseOfferHistoryRequestV5_RoomsCount;
  /** Статус объявлений **/
  offerStatus?: THouseOfferHistoryRequestV5_OfferStatus;
}

export type THouseOfferHistoryRequestV5_IsNearby = null | boolean;

export enum EDealType {
  /** Продажа **/
  'Sale' = 'sale',
  /** Аренда **/
  'Rent' = 'rent',
}
export type THouseOfferHistoryRequestV5_RoomsCount = null | ERoomsCount;

export enum ERoomsCount {
  /** Отдельная комната(покупка/аренда отдельной комнаты в квартире) **/
  'OnlyRoom' = 'onlyRoom',
  /** Студия **/
  'Studio' = 'studio',
  /** Одна комната **/
  'One' = 'one',
  /** Две комнаты **/
  'Two' = 'two',
  /** Три комнаты **/
  'Three' = 'three',
  /** Четыре комнаты **/
  'Four' = 'four',
  /** Пять комнат **/
  'Five' = 'five',
  /** Шесть и более комнат **/
  'SixPlus' = 'sixPlus',
}
export type THouseOfferHistoryRequestV5_OfferStatus = null | EOfferStatus;

export enum EOfferStatus {
  /** Опубликовано **/
  'Published' = 'published',
  /** Снято с публикации **/
  'Deactivated' = 'deactivated',
}
